import {tradeSimulatorView, TradeSimulatorView} from "./view/TradeSimulatorViewComponent";

import Components from "./components";
import {routerConfig} from "./RouterConfig";
import {TradeSimulationService} from "./service/TradeSimulationService";
import {TradeSimulatorViewStoreFactory} from "./service/TradeSimulatorViewStoreFactory";

export default angular.module("tfApp.trade-simulation", [Components])
                      .component(TradeSimulatorView, tradeSimulatorView())
                      .service(TradeSimulationService.id, TradeSimulationService)
                      .service(TradeSimulatorViewStoreFactory.id, TradeSimulatorViewStoreFactory)
                      .config(routerConfig)
                      .name;
